<template>
  <!-- 公告栏看板 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">公告栏看板</span>
    </div>
    <div class="dataWarp" id="dataWarp" @scroll.prevent>
      <div class="ulDiv" id="ulDiv" @scroll.prevent>
        <div class="dataItem" @scroll.prevent
          :class="{ dataItemNormal: item.status == 0, dataItemWarning: item.status == 1, dataItemForewarning: item.status == 2 }"
          v-for="(item, index) in dataList" :key="index">
          <span class="dataItemTitle" :style="[item.status == 1 ?
            { color: '#FF3636' } : item.status == 2 ?
              { color: '#ffa500' } : { color: '#00EBEE' }]">
            <a-tooltip>
              <template slot="title">{{ item.title }}</template>
              {{ item.title }}
            </a-tooltip>
          </span>
          <span class="dataItemTime" :style="[item.status == 1 ? { color: 'rgba(255,54,54,0.75' } : item.status == 2 ?
            { color: 'rgba(255,105,0,0.55)' } :
            { color: 'rgba(11,208,245,0.75)' }]">{{
              item.time
            }}</span>
        </div>
      </div>
      <div id="ulDiv2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletinBoard',
  components: {},
  data () {
    return {
      dataList: [],
      leeonmo: false,
      speed: 50,
      colee: '',
      colee1: '',
      colee2: ''
    }
  },
  created () { },
  mounted () {
    const that = this
    that.getKanbanDataDP(
      // 自动刷新获取数据(1000*60*60=>毫秒*秒*分钟，此时表示为60分钟)
      (that.refreshData = setInterval(() => {
        var i = 1
        i++
        that.dataList = []
        that.leeonmo = true
        this.getKanbanDataDP(i)
      }, 1000 * 60 * 10))
    )
    // this.myScroll()
  },
  methods: {
    getKanbanDataDP () {
      const that = this
      that.$http.get('/pipe-network/bulletin_board/kanban/7').then((res) => {
        that.dataList = res.data
        if (that.dataList.length > 5) {
          that.$nextTick(() => {
            that.goScroll()
          })
        }
      })
    },
    goScroll () {
      const vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的
      if (this.leeonmo === false) {
        this.colee.onmouseover = function () {
          clearInterval(MyMar1)
        }
        this.colee.onmouseout = function () {
          MyMar1 = setInterval(() => {
            vm.Marquee1()
          }, vm.speed)
        }
      } else {
        clearInterval(MyMar1)((MyMar1 = null))
        this.colee.onmouseout = function () {
          MyMar1 = setInterval(() => {
            vm.Marquee1()
          }, vm.speed)
        }
      }
      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1 () {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 349px;
  width: 408px;
  background: url(~@/assets/myImg/h_1_02_box.png) no-repeat;
  background-size: contain;
  position: relative;

  // padding-left:20px;
  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .dataWarp {
    height: 280px;
    width: 388px;
    padding: 0 20px;
    overflow-x: hidden;

    .dataItem {
      width: 368px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      margin-top: 20px;

      .dataItemTitle {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 15px;
        // color: #00ebee;
        font-weight: 600;
        width: 240px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .dataItemTime {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: rgba(11, 208, 245, 0.75);
        text-align: right;
        font-weight: 400;
      }
    }

    //  :nth-of-type(1) {
    //    margin:0
    //   };
    .dataItemNormal {
      background: url(~@/assets/myImg/content-box-04.png) no-repeat;
      background-size: cover;
    }

    .dataItemWarning {
      background: url(~@/assets/myImg/content-box-05.png) no-repeat;
      background-size: cover;
    }

    .dataItemForewarning {
      background: url(~@/assets/myImg/content-box-05.png) no-repeat;
      background-size: cover;
    }
  }
}

::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
